export const getImgPath = (value) => {
    try {
        return require('assets/img/assets/flags/' + value + '.svg') !== undefined
            ? require('assets/img/assets/flags/' + value + '.svg')
            : null;
    } catch (e) {
        return null;
    }
};
